import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > 40) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }

      if (currentScrollY > lastScrollY && currentScrollY > 120) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isVisible ? 'navbar-visible' : 'navbar-hidden'} ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-container">
        {/* Brand Logo */}
        <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
          <img src="/logo.png" alt="SOFTORA" className="logo-image" />
        </Link>

        {/* Desktop Navigation Links */}
        <div className="navbar-menu">
          <div className="navbar-links">
            <NavLink
              to="/"
              end
              className={({ isActive }) => `navbar-link ${isActive ? 'active' : ''}`}
            >
              HOME
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) => `navbar-link ${isActive ? 'active' : ''}`}
            >
              ABOUT
            </NavLink>
            <NavLink
              to="/services"
              className={({ isActive }) => `navbar-link ${isActive ? 'active' : ''}`}
            >
              SERVICES
            </NavLink>
            <NavLink
              to="/technologies"
              className={({ isActive }) => `navbar-link ${isActive ? 'active' : ''}`}
            >
              TECHNOLOGIES
            </NavLink>
            <NavLink
              to="/contact"
              className={({ isActive }) => `navbar-link ${isActive ? 'active' : ''}`}
            >
              CONTACT
            </NavLink>
          </div>

          <Link to="/contact" className="navbar-cta-btn">
            <span>GET IN TOUCH</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>

          {/* Mobile Hamburger Toggle */}
          <button
            type="button"
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {/* Mobile Navigation Dropdown / Drawer */}
        <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <div className="mobile-menu-links">
            <NavLink
              to="/"
              end
              className={({ isActive }) => `mobile-navbar-link ${isActive ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              HOME
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) => `mobile-navbar-link ${isActive ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              ABOUT
            </NavLink>
            <NavLink
              to="/services"
              className={({ isActive }) => `mobile-navbar-link ${isActive ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              SERVICES
            </NavLink>
            <NavLink
              to="/technologies"
              className={({ isActive }) => `mobile-navbar-link ${isActive ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              TECHNOLOGIES
            </NavLink>
            <NavLink
              to="/contact"
              className={({ isActive }) => `mobile-navbar-link ${isActive ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              CONTACT
            </NavLink>
            
            <Link to="/contact" className="mobile-cta-btn" onClick={closeMobileMenu}>
              START A PROJECT →
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;